import { Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBill,
  faUsers,
  faUser,
  faClock,
  faTasks,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

const Features = () => {
  const [location, setLocation] = useState();
  useEffect(() => {
    const tmpLocation = window.location.hostname;
    setLocation(tmpLocation);
  }, []);

  return location !== "demo.freelancersplace.net" ? (
    <Container fluid>
      <Row className="opacity-bg lp-features-bar">
        <Row className="justify-content-center">
          {[
            { icon: faMoneyBill, label: "Billing", href: null },
            { icon: faUsers, label: "CRM", href: null },
            { icon: faUser, label: "CVs", href: null },
            { icon: faClock, label: "Timetracking", href: null },
            { icon: faTasks, label: "Projects", href: null },
            { icon: faBullseye, label: "Applications", href: "/applicationtracker" },
          ].map(({ icon, label, href }) => (
            <Col md={2} sm={4} xs={6} key={label} style={{ textAlign: "center", padding: "1rem 0.5rem", color: "white" }}>
              {href ? (
                <a href={href} style={{ color: "white", textDecoration: "none" }}>
                  <div style={{ marginBottom: "0.5rem" }}><FontAwesomeIcon icon={icon} size="lg" /></div>
                  <div style={{ fontFamily: "Sofia Sans", fontSize: "1rem", fontWeight: 500 }}>{label}</div>
                </a>
              ) : (
                <>
                  <div style={{ marginBottom: "0.5rem" }}><FontAwesomeIcon icon={icon} size="lg" /></div>
                  <div style={{ fontFamily: "Sofia Sans", fontSize: "1rem", fontWeight: 500 }}>{label}</div>
                </>
              )}
            </Col>
          ))}
        </Row>
      </Row>
    </Container>
  ) : (
    <Container fluid style={{ padding: 0 }}>
      <div className="opacity-bg" style={{ minHeight: "unset", padding: "1.5rem 2rem" }}>
        <div style={{
          maxWidth: "860px", margin: "0 auto",
          display: "flex", flexDirection: "column", gap: "1rem",
        }}>

          {/* header row */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{
              background: "rgba(255,255,255,0.15)", color: "#fff",
              fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase",
              letterSpacing: "0.1em", padding: "4px 10px", borderRadius: "20px",
              border: "1px solid rgba(255,255,255,0.25)",
            }}>Demo</span>
            <span style={{
              fontFamily: "'Space Grotesk', sans-serif", fontSize: "0.92rem",
              fontWeight: 600, color: "rgba(255,255,255,0.9)",
            }}>
              Use any of the accounts below to explore the demo
            </span>
          </div>

          {/* credential cards */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
            {[
              { email: "demouser_mueller@freelancersplace.net", initial: "M" },
              { email: "leon_schmidt@freelancersplace.net", initial: "L" },
            ].map(({ email, initial }) => (
              <div key={email} style={{
                display: "flex", alignItems: "center", gap: "12px",
                background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "10px", padding: "10px 16px",
                backdropFilter: "blur(4px)",
              }}>
                <div style={{
                  width: "34px", height: "34px", borderRadius: "50%",
                  background: "rgba(255,255,255,0.25)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 700, fontSize: "0.95rem", color: "#fff", flexShrink: 0,
                }}>{initial}</div>
                <div>
                  <div style={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontSize: "0.85rem", fontWeight: 600, color: "#fff",
                    letterSpacing: "0.01em",
                  }}>{email}</div>
                  <div style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.65)", marginTop: "2px" }}>
                    Password: <span style={{ fontWeight: 600, color: "rgba(255,255,255,0.85)" }}>password</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* warning */}
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "7px",
            fontSize: "0.78rem", color: "rgba(255,220,100,0.95)", fontWeight: 500,
          }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Data resets every 30 minutes. File upload is disabled on the demo system.
          </div>

        </div>
      </div>
    </Container>
  );
};

export default Features;
